<template>
  <div>
    <img class="vue-map w-full h-auto" :src="source" alt="Main Event Location Map" />
    <!-- <gmap-map :style="{height:mainHeight+'px', minHeight:592+'px'}" ref="locationsMap" :center="center" :map-type-id="mapTypeId" :zoom="9" :options="options" class="locations-map">
      <gmap-marker
        v-for="(item, index) in locations"
        :key="index"
        :position="{ lat: item.latitude, lng: item.longitude }"
        :icon="require('~/assets/img/icons/location.svg')"
        @click="center = { lat: item.latitude, lng: item.longitude }"
      />
    </gmap-map> -->
    <!-- <button @click="addLocation({position: { lat: -3.350235, lng: 111.995865 }})">Add Location</button> -->
  </div>
</template>

<script>
import mapStyles from '~/assets/src/map-styles.json'

export default {
  props: ['locations'],
  data() {
    return {
      center: { lat: 29.761249403500493, lng: -95.36964115446376 },
      mapTypeId: "terrain",
      mainHeight: 592,
      markers: [],
      options: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      },
      icon: 'https://images.ctfassets.net/3dar4x4x74wk/38wLCnhmZgEAINii0Oo61l/df88d5cd0a031d5a1f6e1d16019500b9/location-new-pink.png'
    }
  },
  computed: {
    mapStyle() {
      const mapStyle =  mapStyles.map((m,i)=>{
          const stylers =  m.stylers.map( (n)=>   `${Object.keys(n)}:${Object.values(n)}`  )
          return  `feature:${m.featureType}|element:${m.elementType}|${stylers.join('|')}`  
      })  
      return `&style=${mapStyle.join('&style=').replace(/#/g,'0x')}`
    },
    source() {
      if(this.locations.length == 0) {
        return 'https://images.ctfassets.net/3dar4x4x74wk/7l1DGTpe8snagSc7QE0knE/4cea4dcc216cfb11311bfced4a0f6329/houston-staticmap.png'
      } else {
        const parameters = {
          key: process.env.GOOGLE_MAPS_API_KEY,
          center: `${this.center.lat},${this.center.lng}`,
          size: '528x746',
          scale: 2,
          zoom: 9,
          type: 'roadmap',
        }
        let url = `https://maps.googleapis.com/maps/api/staticmap?${this.$qs(parameters)}${this.mapStyle}&markers=icon:${this.icon}`
        this.locations.map(l => {
          url += `%7C${l.latitude},${l.longitude}`
        })
        return url
      }
    }
  },
  watch: {
    locations() {
      if (this.locations[0] !== undefined) {
        this.center = { lat: this.locations[0].latitude, lng: this.locations[0].longitude }
      }
    }
  },
  mounted() {
    if (this.$route.name == 'locations') {
      if (this.locations[0] !== undefined) {
        this.center = { lat: this.locations[0].latitude, lng: this.locations[0].longitude }
      }
      this.mainHeight = 746
      // document.querySelector('.vue-map').style.minHeight = 746 + 'px'

      if (window.outerWidth > 640) {
        // document.querySelector('.vue-map').style.minHeight = 400 + 'px'
      }
    }
    if (this.$route.name == 'locations-state-id') {
      if (this.locations[0] !== undefined) {
        this.center = { lat: this.locations[0].latitude, lng: this.locations[0].longitude }
      }
      this.mainHeight = (document.querySelector('.main .wrapper .w-full').clientHeight - 27)
    }
  },
  methods: {
    addLocation(location) {
        this.markers.push(location);
    }
  }
};
</script>

<style lang="scss">
.vue-map {
  height: 100%;
  min-height: 0;
}
.vue-map-container.locations-map {
  @media (max-width: 640px) {
    height: 400px!important;
    min-height: 400px!important;
  }
}
</style>